(() => {
  'use strict';
  const money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  const rules = window.OctulosImportRules;
  const round = rules.round;
  function initialize(root) {
    if (root.dataset.importReady) return;
    root.dataset.importReady = 'true';
    const form = root.querySelector('[data-import-form]');
    const result = root.querySelector('[data-import-result]');
    const empty = root.querySelector('[data-import-empty]');
    const field = key => form.elements.namedItem(key);
    const today = new Date();
    field('importDate').value = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    let lastCarrier = 'manual';
    let sourceStatus = null;
    let pendingSources = null;
    async function loadSources() {
      if (pendingSources) return pendingSources;
      pendingSources = (async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch('/apps/octulos-inside/import-calculator/sources', { cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('source_status');
          const data = await response.json();
          if (data.ok !== true || !data.sources || !/^\d{4}-\d{2}-\d{2}$/.test(data.server_date)) throw new Error('source_status');
          sourceStatus = data;
          root.querySelector('[data-source-monitor]').textContent = 'Dagelijkse broncontrole op de VM rond 05:15 (Nederlandse tijd). Gewijzigde of onbereikbare bronnen worden niet automatisch gebruikt. Invoerrechten blijven afzonderlijk gecontroleerde tariefregels; de Douane-downloadcontrole vernieuwt deze niet.';
        } catch (_) {
          sourceStatus = null;
          root.querySelector('[data-source-monitor]').textContent = 'Bronstatus niet bereikbaar. Automatische vervoerderkosten zijn tijdelijk onbekend; een eigen offertebedrag blijft mogelijk.';
        } finally { clearTimeout(timer); }
      })();
      try { await pendingSources; } finally { pendingSources = null; }
    }
    function refreshRules() {
      const input = { code: field('code').value.trim(), origin: field('origin').value, date: field('importDate').value, proof: field('proof').checked };
      const tariff = rules.tariff(input);
      const auto = field('tariffMode').value === 'auto';
      field('duty').readOnly = auto;
      if (auto) field('duty').value = tariff.rate === null ? '' : String(tariff.rate);
      const tariffStatus = root.querySelector('[data-tariff-status]');
      tariffStatus.replaceChildren();
      if (auto && tariff.rate === 2.7) {
        const title = document.createElement('strong');
        title.textContent = '2,7% standaard invoerrecht';
        tariffStatus.append(title, document.createElement('br'));
      }
      tariffStatus.append(document.createTextNode(auto ? `${tariff.message} Tarief inhoudelijk gecontroleerd: ${rules.checked}; geen live tariefopvraag.` : 'Handmatig tarief: controleer code, oorsprong, peildatum en voorwaarden bij de Douane.'));
      const params = new URLSearchParams({sd: input.date, d: 'I', cc: /^[0-9]{10}$/.test(input.code) ? input.code : '', co: /^[A-Z]{2}$/.test(input.origin) ? input.origin : '', cu: 'EUR', l: 'nl'});
      root.querySelector('[data-tariff-source]').href = `https://tarief.douane.nl/ite-tariff-public/#/taric/measure/mcc/search?${params}`;
      const selected = field('carrier').value;
      root.querySelector('[data-carrier-notice]').hidden = selected === 'manual';
      const isDhl = selected === 'dhl';
      root.querySelector('[data-dhl-account]').hidden = !isDhl;
      field('dhlAccount').disabled = !isDhl;
      field('dhlAccount').required = isDhl;
      field('origin').required = auto;
      field('code').required = auto;
      field('duty').required = !auto;
      for (const key of ['tariffMode','carrier','vat']) field(key).required = true;
      for (const input of form.querySelectorAll('input, select')) {
        const label = input.closest('label');
        if (!label) continue;
        let marker = label.querySelector('[data-required-marker]');
        if (!marker) {
          marker = document.createElement('span');
          marker.dataset.requiredMarker = '';
          marker.className = 'oct-import__required';
          marker.textContent = ' *';
          marker.setAttribute('aria-hidden','true');
          // Keep the field name and its marker together in this flex label.
          const title = document.createElement('span');
          while (label.firstChild && label.firstChild !== input && label.firstChild.nodeType === 3) title.append(label.firstChild);
          title.append(marker);
          label.insertBefore(title, label.firstChild);
        }
        marker.hidden = !input.required || input.disabled;
        input.setAttribute('aria-required', String(input.required && !input.disabled));
      }
      if (selected !== lastCarrier) field('clearance').value = '';
      lastCarrier = selected;
      const has = key => field(key).value.trim() !== '' && Number.isFinite(Number(field(key).value));
      const customs = round(Number(field('goods').value) + Number(field('freight').value));
      const duty = round(customs * Number(field('duty').value) / 100);
      const vat = round((customs + duty + Number(field('onward').value)) * Number(field('vat').value) / 100);
      const fee = rules.carrierFee({ sourceStatus, carrier: selected, dhlAccount: field('dhlAccount').value, date: input.date, goods: Number(field('goods').value), duty, vat, complete: ['goods','freight','duty','onward'].every(has), manual: has('clearance') ? Number(field('clearance').value) : null });
      field('clearance').readOnly = selected !== 'manual';
      if (selected !== 'manual') field('clearance').value = fee.amount === null ? '' : String(fee.amount);
      root.querySelector('[data-carrier-status]').textContent = fee.message + (selected === 'manual' ? '' : ` Tarief beoordeeld: ${rules.checked}. Laatste geslaagde bronopvraag: ${sourceStatus?.sources?.[selected]?.last_success_at ? new Date(sourceStatus.sources[selected].last_success_at * 1000).toLocaleString('nl-NL', { timeZone: 'Europe/Amsterdam' }) : 'onbekend'}. Eventuele btw op de dienst en extra diensten niet apart berekend.`);
      const sources = { postnl: 'https://www.postnl.nl/klantenservice/inklaringskosten/berekenen/', fedex: 'https://images.fedex.com/en-nl/shipping/rates/fedex-rates.html', dhl: 'https://mydhl.express.dhl/content/dam/downloads/nl/en/rate-guide/service_and_rate_guide_nl_en_2026.pdf.coredownload.pdf', ups: 'https://assets.ups.com/adobe/assets/urn:aaid:aem:a531f567-0f74-4008-bbe8-0e544563f0c5/original/as/service-guide-base-nl-gb-en.pdf' };
      const source = root.querySelector('[data-carrier-source]');
      source.hidden = !sources[selected];
      if (sources[selected]) source.href = sources[selected];
    }
    const product = form.elements.namedItem('product');
    const code = form.elements.namedItem('code');
    let suggestedCode = false;
    function matchProduct() {
      // Curated test record, not a live EAN database. Preserve leading zero.
      const ean = product.value.replace(/(?:&#x20;|&#32;|&nbsp;)/gi, ' ').trim();
      const matched = ean === '0196214000339';
      root.querySelector('[data-import-match]').hidden = !matched;
      if (matched && !code.value) { code.value = '9504400000'; suggestedCode = true; }
      if (!matched && suggestedCode) { code.value = ''; suggestedCode = false; }
    }
    product.addEventListener('input', matchProduct);
    code.addEventListener('input', () => { suggestedCode = false; });
    matchProduct();
    const dispatch = form.elements.namedItem('dispatch');
    const dispatchOther = form.elements.namedItem('dispatchOther');
    function updateDispatch() {
      const other = dispatch.value === 'OTHER';
      root.querySelector('[data-dispatch-other]').hidden = !other;
      dispatchOther.disabled = !other;
      dispatchOther.required = other;
    }
    dispatch.addEventListener('change', updateDispatch);
    updateDispatch();
    function invalidate(event) {
      if (event && ['origin', 'code', 'product', 'importDate'].includes(event.target.name)) field('proof').checked = false;
      result.hidden = true; empty.hidden = false; refreshRules();
    }
    refreshRules();
    form.addEventListener('input', invalidate);
    form.addEventListener('change', invalidate);
    loadSources().then(invalidate);
    let calculating = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (calculating) return;
      calculating = true;
      const submit = form.querySelector('[type=submit]');
      submit.disabled = true;
      await loadSources();
      calculating = false;
      submit.disabled = false;
      refreshRules();
      if (!form.reportValidity()) { invalidate(); return; }
      const values = {};
      const missing = ['onward', 'clearance', 'duty'].filter(key => form.elements.namedItem(key).value.trim() === '');
      for (const key of ['goods', 'freight', 'onward', 'clearance', 'quantity', 'duty', 'vat']) {
        values[key] = Number(form.elements.namedItem(key).value);
        if (!Number.isFinite(values[key])) { invalidate(); return; }
      }
      const customs = round(values.goods + values.freight);
      const duty = round(customs * values.duty / 100);
      const basis = round(customs + duty + values.onward);
      const cost = round(basis + values.clearance);
      const vat = round(basis * values.vat / 100);
      const output = { customs, duty, onward: values.onward, clearance: values.clearance, basis, vat, headline: round(cost + vat), total: round(cost + vat), unit: cost / values.quantity };
      for (const [key, value] of Object.entries(output)) root.querySelector(`[data-import-output="${key}"]`).textContent = money.format(value);
      const names = { onward: 'vervoer na de EU-grens', clearance: 'afhandelingskosten vervoerder', duty: 'invoerrechten' };
      for (const key of missing) root.querySelector(`[data-import-output="${key}"]`).textContent = 'Onbekend';
      const incomplete = missing.length > 0;
      root.querySelector('[data-import-missing]').textContent = incomplete ? `Onvolledige berekening: ${missing.map(key => names[key]).join(', ')} ontbreken. Deze posten en hun btw-effect zijn niet opgenomen in de onderstaande subtotalen.` : '';
      root.querySelector('[data-import-cost-label]').textContent = incomplete ? 'Subtotaal incl. berekende btw — kosten ontbreken' : 'Totaal incl. invoer-btw en ingevulde kosten';
      root.querySelector('[data-import-basis-label]').textContent = incomplete ? 'Voorlopige btw-grondslag' : 'Grondslag invoer-btw';
      root.querySelector('[data-import-vat-label]').textContent = incomplete ? 'Btw over bekende kosten' : 'Invoer-btw';
      root.querySelector('[data-import-total-label]').textContent = incomplete ? 'Subtotaal incl. berekende btw' : 'Totaal incl. invoer-btw';
      root.querySelector('[data-import-unit-label]').textContent = incomplete ? 'Bekende kosten per stuk excl. invoer-btw' : 'Per stuk excl. invoer-btw';
      root.querySelector('[data-import-reference]').textContent = form.elements.namedItem('product').value.trim();
      const from = dispatch.value === 'OTHER' ? dispatchOther.value.trim() : dispatch.selectedOptions[0].textContent;
      const origin = form.elements.namedItem('origin').value.trim() || 'onbekend';
      root.querySelector('[data-import-route]').textContent = `${from} → Nederland · Oorsprong: ${origin}. Goederencode: ${code.value || 'onbekend'}. ${missing.includes('duty') ? 'Invoertarief onbekend.' : (field('tariffMode').value === 'auto' ? 'Tarief uit gecontroleerde tabel.' : 'Tarief handmatig ingevuld.')}`;
      empty.hidden = true;
      result.hidden = false;
    });
    root.querySelector('[data-import-example]').addEventListener('click', () => {
      field('tariffMode').value = 'manual';
      field('carrier').value = 'manual';
      refreshRules();
      const example = { product: 'Rekenvoorbeeld — fictief invoertarief', code: '', goods: '1000', freight: '100', onward: '20', clearance: '25', quantity: '100', duty: '4', vat: '21' };
      for (const [key, value] of Object.entries(example)) form.elements.namedItem(key).value = value;
      suggestedCode = false;
      matchProduct();
      form.requestSubmit();
    });
  }
  function scan() { document.querySelectorAll('[data-import-calculator]').forEach(initialize); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
